<template>
  <loader :task="task" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, QueryResult, ClientFilters } from '@/type';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import repository from './client-repository';

interface Data {
  task: Promise<QueryResult<Client>>|null,
}

export default defineComponent({
  emits: ['loaded'],
  components: {
    Loader,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    filters: {
      type: Object as () => ClientFilters,
    },
    fields: {
      type: Array as () => string[],
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    load(): void {
      this.task = repository.findAll(this.customerId, this.filters, this.fields);
      this.task.then((result: QueryResult<Client>) => {
        this.$emit('loaded', result);
      });
    },
  },
});
</script>
